import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

export type DealCardAdminNotesProps = {
  className?: string
  style?: React.CSSProperties
  adminNotes: string
}

export const DealCardAdminNotes = React.memo(({ className, style, adminNotes }: DealCardAdminNotesProps) => {
  const { classes } = useStyles()
  return (
    <div className={className} style={style}>
      <Typography className={classes.title} variant="body1" gutterBottom>
        Notes on the corporate
      </Typography>
      <Typography variant="body1" className={classes.adminNotes}>
        <span dangerouslySetInnerHTML={{ __html: adminNotes }} />
      </Typography>
    </div>
  )
})

DealCardAdminNotes.displayName = 'DealCardAdminNotes'

const useStyles = makeStyles()(({ typography }: Theme) => ({
  adminNotes: {
    whiteSpace: 'pre-line',
  },
  title: {
    fontWeight: typography.fontWeightBold,
  },
}))
